import axios from "axios";
import { serviceUrl } from "../config";

const BACKEND_URL = serviceUrl;

// export const getUsers = async () => {
//   try {
//     const data = JSON.stringify({
//       svc: "app_2003",
//       pid: "ListCustomerByPrograms",
//       dat: {
//         location: "",
//         franchiseeid: "117",
//         firstname: "",
//         lastname: "",
//         phoneno: "",
//         cityname: "",
//         stateid: "",
//         countryid: "",
//         other1: "",
//         other2: "",
//         other3: "",
//         usertype: "0",
//         startuserid: "0",
//         limit: "0",
//       },
//     });

//     const config = {
//       method: "post",
//       url: BACKEND_URL,
//       headers: {
//         "Content-Type": "application/json",
//         // Cookie: "PHPSESSID=rvrlpdaj6v419pl7op1p8j1o0t",
//         // body: data,
//       },
//       data: data,
//     };

//     const response = await axios(config);
//     console.log(response.data);
//     return response.data;
//   } catch (error) {
//     console.log(error);
//   }
// };

export const login = async (username, password, deviceToken, viewID, method, countryCode) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      // pid: "MerchantLogin",
      pid: "MerchantLogin2",
      dat: {
        location: "",
        username: username,
        password: password,
        _devicetoken: deviceToken,
        _viewid: viewID,
        method: method,
        countryCode: countryCode
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
        // Cookie: "PHPSESSID=rvrlpdaj6v419pl7op1p8j1o0t",
        // body: data,
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const MFAGoogle = async (userid, username, label, authcode) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "GoogleMFA",
      dat: {
        location: "",
        userid: userid,
        username: username,
        label: label,
        authcode: authcode,
      },
    });

    console.log(data)

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
        // Cookie: "PHPSESSID=rvrlpdaj6v419pl7op1p8j1o0t",
        // body: data,
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetUserExternalRef = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "GetUserExternalRef",
      dat: {
        location: "",
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
        // Cookie: "PHPSESSID=rvrlpdaj6v419pl7op1p8j1o0t",
        // body: data,
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CreateUserExternalRef = async (userid, refcode) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "GetUserExternalRef",
      dat: {
        location: "",
        userid: userid,
        refcode: refcode,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const UpdateUserExternalRef = async (userid, refcode, refid, active) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "UpdateUserExternalRef",
      dat: {
        location: "",
        userid: userid,
        refcode: refcode,
        refid: refid,
        active: active,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const sendOTP = async (userid, username, otptype, deviceAuthCredentials) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "sendOTP",
      dat: {
        userid: userid,
        username: username,
        otptype: otptype,
        ...deviceAuthCredentials
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const verifyOTP = async (userid, deviceToken, otp) => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "verifyOTP",
      dat: {
        userid: userid,
        _deviceToken: deviceToken,
        otp: otp
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};